<div
  class="flag {{ styleClass }}"
  [attr.data-size]="size"
  [attr.data-type]="type"
>
  @if (country) {
  <img
    alt="flag"
    class="flag-picture"
    [src]="country | src : 'country-flag'"
  />
  }
</div>
